import type { DrawingProps } from "./types";

/** A photo too soft to read. The blur is ours to fix, never the child's work. */
export function SoftPhoto({ size = 96, className, title }: DrawingProps) {
  return (
    <svg
      width={size}
      height={(size * 84) / 96}
      viewBox="0 0 96 84"
      fill="none"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <defs>
        <filter id="mh-soft" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2.4" />
        </filter>
      </defs>
      <rect x="6" y="10" width="70" height="64" rx="8" fill="var(--white)" stroke="var(--ink)" strokeWidth="2.5" />
      <g filter="url(#mh-soft)">
        <path d="M18 30h44M18 41h50M18 52h30" stroke="var(--sage-deep)" strokeWidth="3.4" strokeLinecap="round" />
      </g>
      <circle cx="74" cy="58" r="15" fill="var(--sky-tint)" stroke="var(--ink)" strokeWidth="2.5" />
      <path d="M67 55h14M67 62h9" stroke="var(--slate)" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M85 69 92 76" stroke="var(--ink)" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}
